import { IUser } from './user';

export interface IUserProfileResponse {
    data: {
        success: boolean;
        user: IUser;
    }
}
